const light = '#8C8D8D'
const main = '#444A51'
const dark = '#2A3037'
const shadow = '#ebeded'

export default {
  light,
  main,
  dark,
  shadow,
  4: '#f8f8f8',
  50: '#EAECEC',
  100: '#D8DADA',
  150: '#A6AAAA',
  200: light,
  300: main,
  400: dark,
}
